import { Routes } from "@src/context/router/RouterContext";
import { type GQLRecentlyViewedModelFragment } from "@src/graphql.generated";
import { useGlobalState } from "@src/hooks/useGlobalState";
import { useRouter } from "@src/hooks/useRouter";
import { type FunctionComponent } from "react";

import { Card, ImageContent, ModelImage, TextContent, TypographyWithEllipsis } from "./RecentlyViewedCard.styles";

export const dataTestId = {
    container: "sparePartsFinder.landingPage.recentlyViewed.card.container",
    modelImage: "sparePartsFinder.landingPage.recentlyViewed.card.modelImage",
};

interface RecentlyViewedCardProps {
    model: GQLRecentlyViewedModelFragment;
}

export const RecentlyViewedCard: FunctionComponent<RecentlyViewedCardProps> = ({ model, ...restProps }) => {
    const { setModelId } = useGlobalState();
    const { setRoute } = useRouter();

    const onClick = () => {
        setRoute(Routes.ComponentGroupOverview);
        setModelId(model.id);
    };

    return (
        <Card data-testid={dataTestId.container} onClick={onClick} {...restProps}>
            <ImageContent>
                <ModelImage src={model.assetPath} data-testid={dataTestId.modelImage} />
            </ImageContent>

            <TextContent>
                <TypographyWithEllipsis variant="label-01">{model.description}</TypographyWithEllipsis>
            </TextContent>
        </Card>
    );
};
